module.exports = __webpack_public_path__ + "static/media/7.0b7a7fc8.png";